<script setup>
import { onBeforeUnmount, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: () => false,
  },
  clickOutside: {
    type: Boolean,
    default: () => false,
  },
  title: {
    type: String,
    default: () => '',
  },
  width: {
    type: Number,
    default: () => 600,
  },
  isLoading: {
    type: Boolean,
    default: () => false,
  },
  escClose: {
    type: Boolean,
    default: () => true,
  },
});

const emit = defineEmits(['update:isVisible', 'close']);

// const route = useRoute();

const handleClickOutside = () => {
  if (props.clickOutside) {
    close();
  }
};

const keyupHandler = (e) => {
  if (!props.escClose) return;
  if (e.key === 'Escape') {
    close();
  }
};


const close = () => {
  // emit('update:isVisible', false);
  emit('close');
};

// watch(  () => route.path, () => {
//   close();
// });

onMounted(() => {
  window.addEventListener('keyup', keyupHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', keyupHandler);
});
</script>

<template>
  <Transition
    name="fade"
    appear
  >
    <div
      v-if="isVisible"
      class="popup"
    >
      <div
        class="popup__overlay"
        @click.self="handleClickOutside"
      >
        <div
          class="popup__window"
          :style="{
            width: `${width}px`,
          }"
        >
          <div class="popup__header">
            <div class="popup__title">
              <slot name="title">
                {{ title }}
              </slot>
            </div>
            <div
              class="popup__close"
              @click="close"
            >
              <UiIcon
                :size="20"
                color="inherit"
                name="times"
              />
            </div>
          </div>
          <UiScrollbar
            wrap-style="max-height: 75vh; height: auto;"
            :native="false"
          >
            <div
              v-loading="isLoading"
              class="popup__body"
            >
              <slot name="body" />
            </div>
          </UiScrollbar>
          <div class="popup__footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss">
.popup {
  //position: relative; после замены попапов вернуть этот
  position: absolute;
  //z-index: 2103;
  z-index: 900;
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(48, 54, 52, 0.5);

    display: flex;
    align-items: center;
  }
  &__window {
    margin: 0 auto;
    position: relative;
    border-radius: 8px;
    background: #FFF;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    color: var(--text-body);
    border-bottom: 1px solid var(--border-default);
  }
  &__title {
    font-size: 20px;
    font-weight: 500;
    padding-right: 12px;
  }
  &__close {
    cursor: pointer;
    transition: all 0.2s ease-out 0s;
    &:hover {
      color: var(--border-focused);
    }
  }

  &__body {
    padding: 16px 24px;
  }
  &__footer {
    border-top: 1px solid var(--border-default);
    padding: 16px 24px;
  }
}
</style>
